import { render, staticRenderFns } from "./CatalogAdd.vue?vue&type=template&id=42b0a78b"
import script from "./CatalogAdd.vue?vue&type=script&lang=js"
export * from "./CatalogAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports